import cn from "classnames";
import {
  Close as CloseIcon,
  ArrowLeft as ArrowLeftIcon,
} from "@rshbintech.dboul/icons";
import { DialogButton } from "../../dialog-button";
import { DialogTitle } from "./dialog-title";
import { DialogHeaderProps } from "./types";
import styles from "./styles.module.scss";

export const DialogHeader = ({
  title,
  showCloseIcon,
  onClose,
  onBack,
  dataTestId,
  className,
}: DialogHeaderProps) => {
  const titleContent =
    typeof title === "string" ? <DialogTitle>{title}</DialogTitle> : title;

  const headerDataTestId = `${dataTestId}-header`;

  return (
    <header
      className={cn(
        styles.header,
        { [styles["only-with-button"]]: !title },
        className
      )}
      data-test-id={headerDataTestId}
    >
      <div
        className={cn(styles["header-inner"], {
          [styles["only-with-close-button"]]: !title && !onBack,
          [styles["without-title"]]: !title && onBack,
        })}
        data-test-id={`${headerDataTestId}-inner`}
      >
        {onBack && (
          <DialogButton
            fullscreen
            className={styles["back-button"]}
            dataTestId={`${dataTestId}-back-button`}
            onClick={onBack}
          >
            <ArrowLeftIcon size="medium" />
          </DialogButton>
        )}

        <div className={styles["title-box"]}>{titleContent}</div>

        {showCloseIcon && (
          <DialogButton
            fullscreen
            className={styles["close-button"]}
            dataTestId={`${dataTestId}-close-button`}
            onClick={onClose}
          >
            <CloseIcon size="medium" />
          </DialogButton>
        )}
      </div>
    </header>
  );
};
